<!-- @format -->
<!-- Translated: yes -->
<template>
  <div>
    <div
      class="box center"
      v-if="SITE_CONFIG.site === 'branas' || SITE_CONFIG.site === 'kungsberget'"
    >
      <!-- <Loading
        v-if="!signedin && !wasSignedIn"
        :show="true"
        :static="true"
        style="height: 50px"
      /> -->
      <img
        v-if="true || (signedin && !wasSignedIn)"
        src="https://static.booking.branasgruppen.se/static/svg/kortterminal-check.svg"
        style="height: 40px;margin-bottom: 10px;"
      />

      <!-- <p v-if="!signedin && !error">
        Din bokning behandlas. Om du stannar kvar på den här sidan kommer du
        snart att automatiskt bli inloggad.
      </p> -->
      <p v-if="true || (signedin && wasSignedIn)">
        Du kan strax hitta din bokning under
        <a href="#" @click="myPage">Mina sidor</a>
        .
      </p>
      <!-- <p v-if="signedin && !wasSignedIn">
        Du är nu inloggad och kan strax hitta din bokning under
        <a href="#" @click="myPage">Mina sidor</a>
        .
      </p> -->
    </div>

    <CheckUpdateAddress v-if="signedin" />

    <CollectorCheckout :initial-public-token="publicToken"></CollectorCheckout>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import API from '@/classes/API';
import CheckUpdateAddress from '@/components/parts/CheckUpdateAddress';
import CollectorCheckout from '@/components/payments/CollectorCheckout';
import Loading from '@/components/components/Loading';

export default {
  props: {},
  components: {
    CheckUpdateAddress,
    CollectorCheckout,
    Loading,
  },
  data() {
    return {
      snippet: null,
      signedin: false,
      error: false,
      wasSignedIn: false,
    };
  },
  computed: {
    publicToken() {
      return this.$route.query.checkout_session_id;
    },
  },
  async mounted() {
    const cart = Object.assign({}, this.$store.state.cart);
    this.clearCart();

    if (!this.$store.state.user.token) {
      // this.signin();
    } else {
      this.signedin = true;
      this.wasSignedIn = true;
    }

    const { data, orderId, ga, customer } = await API.get(
      `/cart/get-for-pixel?checkout_session_id=${this.$route.query.checkout_session_id}`,
    );

    console.log('Should start transaction');
    console.log(orderId);
    console.log(cart);
    console.log(data.value);
    window.trackPurchase(ga, orderId, data.value, customer);
  },
  methods: {
    ...mapMutations(['openModal']),
    async signin() {
      const { token, error } = await API.get(
        `/account/signin-from-order?checkout_session_id=${this.$route.query.checkout_session_id}`,
      );

      if (token) {
        this.signedin = true;
        this.setUser({
          token,
        });

        document.body.dispatchEvent(
          new CustomEvent('bookinguserstatechanged', { detail: true }),
        );
      } else if (!error) {
        this.signedin = false;
        setTimeout(this.signin, 3000);
      } else {
        this.error = error;
      }
    },
    myPage() {
      this.$router.push({
        name: 'my pages journey',
      });
    },
    ...mapMutations(['clearCart', 'setUser']),
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.box
  info-box()
  max-width 600px
  margin 0 auto

.center
  text-align: center
  margin-top 25px
  margin-bottom 15px
</style>



// WEBPACK FOOTER //
// CollectorCheckoutConfirmation.vue?4e333ac4